<fts-editor
  [imageSrc]="orderableItem?.getImage()?.src"
  [orderableItem]="orderableItem"
  [orderedItem]="orderedItem"
  [upsellItems]="upsellItems"
  [theme]="theme"
  [isInCreationMode]="true"
  [storeConfig]="storeConfig"
  [inItemEditorModal]="inItemEditorModal"
  (triggerUpsellsOnSizeChange)="onChangeSizeTriggerUpsells($event)">
</fts-editor>
